// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_34-1";
export var movingGradient = "_34-4";
export var movingGradientBlock = "_34-2";
export var skeleton = "_34-0";
export var skeletonText = "_34-3";